import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-100 mb-3">
            探索分类
          </h2>
          <p className="text-foreground-400 text-sm md:text-base max-w-xl mx-auto">
            按你的兴趣选择分类，找到最适合你的自拍指南
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-medium text-foreground-100 group-hover:text-primary-600 transition-colors mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}